<template lang="pug">
.py-2
  .show-checklist(v-if='checklist')
    .columns
      .column
        .h4 Checklist
      .column.col-auto(v-if="comentario_situacao")
        .chip {{ comentario_situacao.descricao }}
    .pb-2.grupo(v-for='grupo in checklist' :key='grupo.id')
      .divider.text-center(:data-content='grupo.titulo')
      .perguntas(v-for='pergunta in grupo.perguntas' :key='pergunta.id')
        show-pergunta(:pergunta='pergunta')
  .empty.my-2(v-else)
    .empty-icon
      i.fa.fa-search.fa-2x
    .empty-title.h5 Checklist vazio
</template>

<script>
import ShowPergunta from "./Pergunta"

export default {
  props: {
    checklist: { type: [Object, Array], default: null },
    comentario_situacao: Object,
  },
  components: { ShowPergunta },
}
</script>

<style lang="stylus">
.show-checklist
  .grupo
    padding-left 1rem
    .perguntas
      .pergunta
        .titulo
          font-size .8rem
        .resposta
          font-size .7rem
          padding-left 1rem
          padding-bottom 1rem
        .fotos
          padding-left 1rem
          padding-bottom 1rem
          .foto
            max-width 150px
</style>
